import { render, staticRenderFns } from "./DropdownOptionsOptionLabels.vue?vue&type=template&id=5d6a2e2f"
import script from "./DropdownOptionsOptionLabels.vue?vue&type=script&lang=js"
export * from "./DropdownOptionsOptionLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports